
import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        height: "70vh",
        width: "90vw",
        backgroundColor: "white",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "45px 1fr",
        gridTemplateAreas: `'header''content'`,
        alignItems: "flexStart",
        justifyContent: "center",
    },
    boxHeader: {
        display: "flex",
        gridArea: "header",
        flexDirection: "Row",
        flexWrap: "wrap",
        width: "100%",
        height: "40px",
        justifyContent: "center",
        alignItems: "center",
    },
    boxHeaderItens: {
        display: "flex",
        flexDirection: "Row",
        flexWrap: "wrap",
        gap: "15px",
        alignItems: "center",
    },

    boxDataGrid: {
        display: "flex",
        gridArea: "content",
        flexDirection: "Row",
        flexWrap: "wrap",
        gap: "20px",
        width: "100%",
        height: "100%",
        overflow: "auto",
        justifyContent: "space-evenly",
    },

    redLine: {
        backgroundColor: "red",
        color: "white",
    },
    normalLine: {
        backgroundColor: "white",
        color: "black",
    },
    yellowLine: {
        backgroundColor: "yellow",
        color: "black",
    },
    redHead: {
        backgroundColor: "#2471A3",
        color: "white",
    },
    normalHead: {
        backgroundColor: "green",
        color: "black",
    },
    yellowHead: {
        backgroundColor: "yellow",
        color: "black",
    },

    side_content: {
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    header_grid: {
        backgroundColor: "blue",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: "0px",
        right: "0",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
